import React from "react";
import {
  Drawer,
  DrawerBody,
  DrawerFooter,
  DrawerHeader,
  DrawerOverlay,
  DrawerContent,
  DrawerCloseButton,
  Button,
  HStack,
  useDisclosure,
} from "@chakra-ui/react";
import { chipClasses } from "@mui/material";

const DashboardDrawer = ({children, isOpen, onClose}) => {
//   const { isOpen, onOpen, onClose } = useDisclosure(); // Manage drawer state
  const placement = "bottom"; // You can dynamically set this if needed

  return (
    <HStack wrap="wrap" pos={'absolute'} minH={'h-screen'} bg={'#000'} opacity={'25%'} zIndex={'999'}>
      {/* <Button variant="outline" size="sm" onClick={onOpen}>
        Open ({placement})
      </Button> */}
      <Drawer
        isOpen={isOpen}
        placement={placement}
        onClose={onClose}
        size="md" // Adjust size as needed
      >
        <DrawerOverlay />
        <DrawerContent
          borderTopRadius={placement === "bottom" ? "lg" : undefined}
          borderBottomRadius={placement === "top" ? "lg" : undefined}
        >
          <DrawerCloseButton />
          <DrawerHeader>
            {/* Drawer Title */}
          </DrawerHeader>
          <DrawerBody>
           {children}
          </DrawerBody>
          <DrawerFooter>
            <Button onClick={onClose} w={'full'} bg={'#F1613F'} color={'#fff'} display={'inline-flex'} justifyContent={'center'} borderRadius={'27px'} py={3}>
              Apply
            </Button>
            {/* <Button ml={3}>Save</Button> */}
          </DrawerFooter>
        </DrawerContent>
      </Drawer>
    </HStack>
  );
};

export default DashboardDrawer;
